import Flickity from 'flickity';

export const sliders = (() => {
	const c = {
		instances: [],
		swup: undefined, // need reference to swup to manually trigger clicks
	};

	c.init = function() {
		let sliders = Array.from(document.querySelectorAll('.f-carousel'));

		if (!sliders || !sliders.length) {
			return;
		}

		const exclusions = [
			'product-hero__carousel',
			'-custom-flickity',
		];

		sliders = sliders.filter(s => {
			let shouldBeExcluded = false
			exclusions.forEach(exclusion => {
				if (s.classList.contains(exclusion)) {
					shouldBeExcluded = true;
				}
			})

			return !shouldBeExcluded;
		})

		const instances = [];

		sliders.forEach((slider) => {
			let flickity = null;

			let dots = slider.getAttribute('data-dots');
			let nav = slider.getAttribute('data-nav');
			let items = slider.getAttribute('data-items');
			let drag = slider.getAttribute('data-drag');
			let autoHeight = slider.getAttribute('data-auto-height');
			let loop = slider.getAttribute('data-loop');
			let wrapAround = slider.getAttribute('data-wrap-around');

			dots = (dots && dots !== null)
				? JSON.parse(dots.toLowerCase())
				: false;

			items = (items && items !== null)
				? parseInt(items.toLowerCase())
				: 1;

			drag = (drag && drag !== null)
				? JSON.parse(drag.toLowerCase())
				: false;

			autoHeight = (autoHeight && autoHeight !== null)
				? JSON.parse(autoHeight.toLowerCase())
				: true;

			loop = (loop && loop !== null)
				? JSON.parse(loop.toLowerCase())
				: 'lop';

			wrapAround = (wrapAround && wrapAround !== null)
				? JSON.parse(wrapAround.toLowerCase())
				: true;

			//Change the options here - you can use data-* tags to specify different values for different sliders
			let options = {
				wrapAround: wrapAround,
				contain: !loop,
				pageDots: dots,
				accessibility: true,
				arrowShape: 'M60.4,100L16.2,52.5c-1.8-1.9-1.7-4.9,0.1-6.8L60.5,0l7.1,6.8L26.6,49.2l41,44.1L60.4,100z',
				prevNextButtons: nav,
				cellAlign: 'left',
				adaptiveHeight: autoHeight,
				draggable: drag,
				on: {
					change: function(index) {
						if(index === 0) {
							slider.classList.remove('active');
						} else {
							slider.classList.add('active');
						}
					},
					staticClick: function(e) {
						// re-enable swup for this link by the time it's event
						// is received by jquery
						if (e.target.hasAttribute('data-no-swup')) {
							e.target.removeAttribute('data-no-swup');
						}
					},
				},
			};

			const links = slider.querySelectorAll('[data-no-swup]');
			if (links) {
				links.forEach(link => {
					link.addEventListener('click', (e) => {
						e.preventDefault();
					}, { passive: false });
				});
			}

			/**
			 * If nav return Boolean, use default Flickity nav
			 * Else use custom nav
			 */
			if(nav && nav !== null && nav === 'true') {
				options.prevNextButtons = true;
			} else {
				options.prevNextButtons = false;
			}

			const desktopPostGroupSize = 3;
			const mobilePostGroupSize = 1;

			if(slider.classList.contains('module-posts_carousel__carousel')) {
				const mobileBP = '(max-width: 540px)';

				// Options change on breakpoint
				const breakpoint = window.matchMedia(mobileBP);

				const isMobile = (breakpoint) => {
					if(breakpoint.matches) {
						options.cellAlign = 'center';
						options.groupCells = mobilePostGroupSize;
						options.draggable = items > mobilePostGroupSize;
						options.wrapAround = false;

						flickity = new Flickity(slider, options);
					} else {
						options.cellAlign = 'left';
						options.groupCells = desktopPostGroupSize;
						options.wrapAround = items > desktopPostGroupSize;
						options.draggable = items > desktopPostGroupSize;

						flickity = new Flickity(slider, options);
					}
				}

				// Add the match function as a listener for state changes:
				if (breakpoint.addEventListener !== null) {
					breakpoint.addEventListener('change', () => {
						isMobile(breakpoint)
					});
				}

				isMobile(breakpoint);
			} else {
				// Default slider init
				flickity = new Flickity(slider, options);
			}

			if(nav && nav !== null && nav === 'custom' && flickity) {
				const parent = slider.parentNode;

				const prevButton = parent.querySelector('.flickity-button.previous');
				const nextButton = parent.querySelector('.flickity-button.next');

				if(prevButton) {
					prevButton.addEventListener('click', () => {
						flickity.previous(true);
					});
				}

				if(nextButton) {
					nextButton.addEventListener('click', () => {
						flickity.next(true);
					});
				}
			}

			flickity.on('change', (index) => {
				const slideLength = flickity.slides.length;

				if(slider.classList.contains('product-hero__carousel')) {
					const progressBar = slider.parentNode.querySelector('.product-hero__progress');

					if(!progressBar) {
						return;
					}

					progressBar.style.maxWidth = `${((index + 1) / slideLength) * 100}%`;

					if(index === slideLength) {
						slider.classList.remove('carousel-start');
						slider.classList.add('carousel-end');
					} else if(index === 0) {
						slider.classList.remove('carousel-end');
						slider.classList.add('carousel-start');
					} else {
						slider.classList.remove('carousel-start', 'carousel-end');
					}
				}
			})

			instances.push(flickity);

			// resize after page styles load
			window.addEventListener('load', () => {
				c.instances.forEach(instance => {
					instance.resize();
				});
			});
		});

		if (c.instances) {
			c.unload();
		}

		c.instances = instances;
	}





	c.unload = function() {
		if (c.instances) {
			c.instances.forEach(instance => instance.destroy());
			c.instances = [];
		}
	}

	return c;
})();


// // TODO: complete this
// export function CardsCarousel(rootElem) {
// 	const instance = {
// 		rootElem: rootElem || undefined,
// 		carousel: undefined,
// 	}

// 	if (rootElem) {

// 		const standardOptions = {
// 			dots: false,
// 			prevNextButtons: true,
// 			adaptiveHeight: false,
// 			contain: false,
// 			wrapAround: true,
// 			accessibility: true,
// 			arrowShape: 'M60.4,100L16.2,52.5c-1.8-1.9-1.7-4.9,0.1-6.8L60.5,0l7.1,6.8L26.6,49.2l41,44.1L60.4,100z',
// 			cellAlign: 'left',
// 			draggable: true,
// 			on: {
// 				change: function(index) {
// 					if(index === 0) {
// 						this.element.classList.remove('active');
// 					} else {
// 						this.element.classList.add('active');
// 					}
// 				},
// 				staticClick: function(e) {
// 					// re-enable swup for this link by the time it's event
// 					// is received by jquery
// 					if (e.target.hasAttribute('data-no-swup')) {
// 						e.target.removeAttribute('data-no-swup');
// 					}
// 				},
// 			},
// 		}

// 		// const breakpointOptions =

// 		// //Change the options here - you can use data-* tags to specify different values for different sliders
// 		// const overrideOptions = retrieveFlickityDomOptions(rootElem);

// 		// const mergedOptions = Object.assign({}, standardOptions, overrideOptions);

// 		// // //Change the options here - you can use data-* tags to specify different values for different sliders
// 		// // let options = {
// 		// // 	wrapAround: wrapAround,
// 		// // 	contain: !loop,
// 		// // 	pageDots: dots,
// 		// // 	accessibility: true,
// 		// // 	arrowShape: 'M60.4,100L16.2,52.5c-1.8-1.9-1.7-4.9,0.1-6.8L60.5,0l7.1,6.8L26.6,49.2l41,44.1L60.4,100z',
// 		// // 	prevNextButtons: nav,
// 		// // 	cellAlign: 'left',
// 		// // 	adaptiveHeight: autoHeight,
// 		// // 	draggable: drag,
// 		// // 	on: {
// 		// // 		change: function(index) {
// 		// // 			if(index === 0) {
// 		// // 				slider.classList.remove('active');
// 		// // 			} else {
// 		// // 				slider.classList.add('active');
// 		// // 			}
// 		// // 		},
// 		// // 		staticClick: function(e) {
// 		// // 			// re-enable swup for this link by the time it's event
// 		// // 			// is received by jquery
// 		// // 			if (e.target.hasAttribute('data-no-swup')) {
// 		// // 				e.target.removeAttribute('data-no-swup');
// 		// // 			}
// 		// // 		},
// 		// // 	},
// 		// // };

// 		// const links = rootElem.querySelectorAll('[data-no-swup]');
// 		// if (links) {
// 		// 	links.forEach(link => {
// 		// 		link.addEventListener('click', (e) => {
// 		// 			e.preventDefault();
// 		// 		}, { passive: false });
// 		// 	});
// 		// }

// 		// const mobileBP = '(max-width: 540px)';

// 		// // Options change on breakpoint
// 		// const breakpoint = window.matchMedia(mobileBP);

// 		// const isMobile = (breakpoint) => {
// 		// 	if(breakpoint.matches) {
// 		// 		options.cellAlign = 'center';
// 		// 		options.groupCells = 1;
// 		// 		options.wrapAround = false;

// 		// 		cc.carousel = new Flickity(slider, options);
// 		// 	} else {
// 		// 		// options.cellAlign = 'center';
// 		// 		options.groupCells = 3;
// 		// 		options.wrapAround = true;

// 		// 		cc.carousel = new Flickity(slider, options);
// 		// 	}
// 		// }

// 		// // Add the match function as a listener for state changes:
// 		// if (breakpoint.addEventListener !== null) {
// 		// 	breakpoint.addEventListener('change', () => {
// 		// 		isMobile(breakpoint)
// 		// 	});
// 		// }

// 		// isMobile(breakpoint);
// 		// // if(rootElem.classList.contains('module-posts_carousel__carousel')) {
// 		// // } else {
// 		// // 	// Default slider init
// 		// // 	flickity = new Flickity(slider, options);
// 		// // }

// 		// if(nav && nav !== null && nav === 'custom' && flickity) {
// 		// 	const parent = slider.parentNode;

// 		// 	const prevButton = parent.querySelector('.flickity-button.previous');
// 		// 	const nextButton = parent.querySelector('.flickity-button.next');

// 		// 	if(prevButton) {
// 		// 		prevButton.addEventListener('click', () => {
// 		// 			flickity.previous(true);
// 		// 		});
// 		// 	}

// 		// 	if(nextButton) {
// 		// 		nextButton.addEventListener('click', () => {
// 		// 			flickity.next(true);
// 		// 		});
// 		// 	}
// 		// }
// 	}

// 	return instance;
// }


/**
 *
 * @param {HTMLElement} elem
 * @return {Object}
 */
function retrieveFlickityDomOptions(elem) {
	if (!elem) {
		return {};
	}

	// these are all booleans
	const dots = elem.getAttribute('data-dots') === 'true';
	const prevNextButtons = elem.getAttribute('data-nav') === 'true';
	const drag = elem.getAttribute('data-drag') === 'true';
	const autoHeight = elem.getAttribute('data-auto-height') === 'true';
	const loop = elem.getAttribute('data-loop') === 'true';
	const wrapAround = elem.getAttribute('data-wrap-around') === 'true';

	return {
		dots,
		prevNextButtons,
		draggable: drag,
		adaptiveHeight: autoHeight,
		contain: !loop,
		wrapAround,
	}
}


export function HeroCarousel(rootElem) {

	const instance = {
		rootElem: rootElem || undefined,
		carousel: undefined,
	}

	if (rootElem) {

		instance.carousel = new Flickity(rootElem, {
			cellSelector: '.product-hero__cell',
			cellAlign: 'left',
			contain: true,
			setGallerySize: false,
			wrapAround: false,
			adaptiveHeight: false,
			accessibility: true,
			pageDots: false,
			arrowShape: 'M60.4,100L16.2,52.5c-1.8-1.9-1.7-4.9,0.1-6.8L60.5,0l7.1,6.8L26.6,49.2l41,44.1L60.4,100z',
			prevNextButtons: true,
			on: {
				change: function(index) {
					if(index === 0) {
						this.element.classList.remove('active');
					} else {
						this.element.classList.add('active');
					}
				},
				scroll: (progress) => {
					progress = Math.max( 0, Math.min( 1, progress ) );

					const progressBar = document.querySelector('.product-hero__progress-bar');

					if(progressBar) {
						const indicator = progressBar.querySelector('.product-hero__progress');

						indicator.style.width = progress * 100 + '%';
					}
				},
			},
		})
	}



	instance.destroy = function() {
		if (instance.carousel && instance.carousel.destroy) {
			instance.carousel.destroy();
		}

		instance.rootElem = undefined;
		instance.carousel = undefined;
	}

	return instance;
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js